import { ShippingOptions } from '@app/components/ShippingOptions/ShippingOptions';
import {
  useCartAndDeliveryDatesDataContext,
  useCurrency,
  useShippingMethod,
} from '@app/data/clients/cartCheckoutClient';
import { ShippingMethod } from '@app/types/cart/ShippingMethod';

export type MonolithShippingOptionsContainerProps = {
  flatRateApplied?: boolean;
  onChange?: (shippingMethod: ShippingMethod) => Promise<unknown>;
};

export const MonolithShippingOptionsContainer = ({
  onChange,
  flatRateApplied,
}: MonolithShippingOptionsContainerProps) => {
  const currency = useCurrency();
  const shippingMethod = useShippingMethod();
  const {
    cart,
    cartLoading,
    deliveryDates,
    deliveryDatesLoading,
    hasStartedInitialLoad,
  } = useCartAndDeliveryDatesDataContext();

  const shippingEstimates = cart?.summary.estimated_shipping;
  const showTaxSeparately = cart?.summary.show_tax_separately;

  return (
    <ShippingOptions
      shippingMethod={shippingMethod}
      flatRateApplied={flatRateApplied}
      showTaxSeparately={showTaxSeparately}
      shippingEstimates={
        shippingEstimates
          ? {
              standard: {
                amountWithTax: shippingEstimates.standard,
                amountExcludingTax: shippingEstimates.standard_ex_tax,
              },
              express: shippingEstimates.express
                ? {
                    amountWithTax: shippingEstimates.express,
                    amountExcludingTax: shippingEstimates.express_ex_tax,
                  }
                : undefined,
            }
          : undefined
      }
      deliveryDates={deliveryDates || undefined}
      currency={currency}
      onChange={onChange}
      isLoading={
        deliveryDatesLoading ||
        cartLoading ||
        !shippingEstimates ||
        !hasStartedInitialLoad
      }
    />
  );
};
